export default "<section>\n  <app-predictor-section id=\"predictor\"></app-predictor-section>\n</section>"